import React from 'react';
import { Input, Modal } from 'antd';
import commonS from 'styles/common.module.less';
import s from '../s.module.less';

type Props = {
    open: boolean;
    loading?: boolean;
    onCancel: () => void;
    onOk: () => void;

    hasModifiedServiceType: boolean;
    hasModifiedSpecialty: boolean;

    originalServiceType?: string;
    newServiceType?: string;
    originalSpecialty?: string;
    newSpecialty?: string;

    patientFirstName?: string;
    description: string;
    footerNote?: string;

    customMessage?: string;
    onCustomMessageChange: (val: string) => void;

    providerNameDisplay: string;
    providerCredential?: string;
};

const DEFAULT_FOOTER_NOTE = 'If you have any questions or need to make changes, feel free to reach out.';

const ServiceChangeConfirmModal = (props: Props) => {
    const {
        open,
        loading,
        onCancel,
        onOk,
        hasModifiedServiceType,
        hasModifiedSpecialty,
        originalServiceType,
        newServiceType,
        originalSpecialty,
        newSpecialty,
        patientFirstName,
        description,
        footerNote = DEFAULT_FOOTER_NOTE,
        customMessage,
        onCustomMessageChange,
        providerNameDisplay,
        providerCredential,
    } = props;

    return (
        <Modal
            open={open}
            title="Confirm appointment changes"
            width={660}
            okText="Save"
            className={commonS.modalFixHeightWrap}
            onCancel={onCancel}
            onOk={onOk}
            okButtonProps={{ loading }}
        >
            <div className={s.cWrap}>
                <div className={s.cLabel}>
                    You’ve made changes to the appointment. Please review the updated details below:
                </div>
                <div className={s.cPreview}>
                    {hasModifiedServiceType && (
                        <>
                            <div className={s.cPreviewItemOrg}>
                                <div className={s.cPreviewLabel}>Original visit type:</div>
                                <div className={s.cPreviewVal}>{originalServiceType}</div>
                            </div>
                            <div className={s.cPreviewItemNew}>
                                <div className={s.cPreviewLabel}>Updated visit type:</div>
                                <div className={s.cPreviewVal}>{newServiceType}</div>
                            </div>
                        </>
                    )}
                    {hasModifiedSpecialty && (
                        <>
                            <div className={s.cPreviewItemOrg}>
                                <div className={s.cPreviewLabel}>Original specialty:</div>
                                <div className={s.cPreviewVal}>{originalSpecialty}</div>
                            </div>
                            <div className={s.cPreviewItemNew}>
                                <div className={s.cPreviewLabel}>Updated specialty:</div>
                                <div className={s.cPreviewVal}>{newSpecialty}</div>
                            </div>
                        </>
                    )}
                </div>
                <div className={s.msgToWrap}>
                    <div className={s.mtTitle}>Message to patient</div>
                    <div className={s.mtContent}>
                        <div className={s.mtHeader}>Dear {patientFirstName},</div>
                        <div className={s.mtDes}>{description}</div>
                        <div className={s.mtDes}>
                            {hasModifiedServiceType && (
                                <>
                                    <div className={s.org}>
                                        <div className={s.mtDesLabel}>Original visit type:</div>
                                        <div className={s.mtDesVal}>{originalServiceType}</div>
                                    </div>
                                    <div className={s.new}>
                                        <div className={s.mtDesLabel}>Updated visit type:</div>
                                        <div className={s.mtDesVal}>{newServiceType}</div>
                                    </div>
                                </>
                            )}
                            {hasModifiedSpecialty && (
                                <>
                                    <div className={s.org}>
                                        <div className={s.mtDesLabel}>Original specialty:</div>
                                        <div className={s.mtDesVal}>{originalSpecialty}</div>
                                    </div>
                                    <div className={s.new}>
                                        <div className={s.mtDesLabel}>Updated specialty:</div>
                                        <div className={s.mtDesVal}>{newSpecialty}</div>
                                    </div>
                                </>
                            )}
                        </div>
                        <div className={s.mtDes}>{footerNote}</div>
                        <div className={s.mtCus}>
                            <div className={s.mtCusTitle}>
                                Customized message to patient{' '}
                                <span style={{ color: '#8E8E8E' }}>(optional)</span>
                            </div>
                            <div className={s.mtCusValue}>
                                <Input.TextArea
                                    onChange={(e) => onCustomMessageChange(e.target.value)}
                                    value={customMessage}
                                    placeholder="Add customized message..."
                                    rows={4}
                                />
                            </div>
                        </div>
                        <div className={s.mtFooter}>
                            <p>Looking forward to our visit,</p>
                            <p>
                                {providerNameDisplay}
                                {providerCredential ? `, ${providerCredential}` : ''}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default ServiceChangeConfirmModal;
